import React, { useEffect, useState } from 'react'
import { Trans } from '@lingui/macro'
import { Switch } from 'front-end/src/components'
import { ICommentIdentifier } from '../comments-footer/CommentsFooter'
import {
  useFollowResourceMutation,
  useUnfollowResourceMutation
} from './CommentsFollow.codegen'

export type Props = { isFollowing: boolean | undefined } & ICommentIdentifier

export const CommentsFollow: React.FC<Props> = (props) => {
  const [isFollowing, setFollowing] = useState(props.isFollowing)
  useEffect(() => {
    setFollowing(props.isFollowing)
  }, [props.isFollowing])

  const variables = {
    itemId: props.itemId,
    itemType: props.itemType
  }

  const [follow] = useFollowResourceMutation({
    variables
  })
  const [unfollow] = useUnfollowResourceMutation({
    variables
  })

  return (
    <div className="comments-follow">
      <span className="setting-label">
        <Trans>Notify me about new comments</Trans>
      </span>
      <Switch
        ml="8px"
        isChecked={isFollowing}
        onChange={async () => {
          if (isFollowing) {
            await unfollow()
          } else {
            await follow()
          }
          setFollowing(!isFollowing)
        }}
      />
    </div>
  )
}

export default CommentsFollow
